module.exports = __webpack_public_path__ + "img/header-weddingRingsRosegold.7591f1c.jpg";